import React from "react";
import BackgroundVideo from "../../assets/heroVideo.mov";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <div className="hero1-container">
      {/* Background Video */}
      <video autoPlay loop muted playsInline className="hero1-video">
        <source src={BackgroundVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="hero1-overlay" />

      {/* Content */}
      <div className="hero1-content">
        <h1 className="hero1-heading">
          Pansuriya Impex
          <br />
          <h2 className="hero1-subheading" >
            Crafted to Perfection
          </h2>
        </h1>
        <p className="hero1-description">
          Premium natural and lab-grown diamonds manufactured, sold, and
          exported worldwide with uncompromising quality.
        </p>
      </div>
    </div>
  );
};

export default HeroSection;
